/* eslint-disable prefer-destructuring */
export const getDomain = (url) => {
  let hostname = null

  if (url.indexOf('://') > -1) {
    hostname = url.split('/')[2]
  } else {
    hostname = url.split('/')[0]
  }

  // Find & remove port number
  hostname = hostname.split(':')[0]

  // Find & remove "?"
  hostname = hostname.split('?')[0]

  return hostname
}

export const getRootDomain = (url) => {
  const domain = getDomain(url)
  const splitArr = domain.split('.')
  const arrLen = splitArr.length

  // Extracting the root domain here
  if (arrLen > 1 && arrLen < 3) {
    return `${splitArr[arrLen - 2]}.${splitArr[arrLen - 1]}`
  }
  if (arrLen > 2) {
    return `${splitArr[arrLen - 3]}.${splitArr[arrLen - 2]}.${splitArr[arrLen - 1]}`
  }
  return domain
}

export const getBaseDomain = (url) => {
  const domain = getDomain(url)
  const splitArr = domain.split('.')
  const arrLen = splitArr.length

  // Extracting the root domain here
  return `${splitArr[arrLen - 2]}.${splitArr[arrLen - 1]}`
}

export const getDomainItems = (url) => {
  const domain = getDomain(url)
  return domain.split('.')
}

export default {
  getDomain,
  getRootDomain,
  getBaseDomain,
  getDomainItems,
}
